import isBotFast from 'isbot-fast';

// Regex patterns for known AI bots
const AI_BOT_PATTERNS = [/GPTBot/i, /ChatGPT-User/i, /CCBot/i, /anthropic-ai/i, /DuckAssistBot/i, /facebookexternalhit/i, /MistralAI-User/i, /OAI-SearchBot/i, /TikTokSpider/i, /Claude-Web/i, /Claude-User/i, /ClaudeBot/i, /Perplexity-User/i, /PerplexityBot/i, /Meta-ExternalAgent/i, /Meta-ExternalFetcher/i, /Bytespider/i];
function detectAIBot(userAgent) {
  if (!userAgent) return false;
  return AI_BOT_PATTERNS.some(pattern => pattern.test(userAgent));
}
function withCtxIsBot() {
  return async ctx => {
    try {
      // eslint-disable-next-line no-undef
      const userAgent = ctx.req ? ctx.req.headers['user-agent'] : navigator.userAgent;

      // assert isBot on server user agent header or client userAgent
      ctx.data.isBot = isBotFast(userAgent) || false;

      // detect AI bots specifically
      ctx.data.isAIBot = detectAIBot(userAgent);
    } catch (err) {
      // if there is an error asserting the bot then we default to false
      ctx.data.isBot = false;
      ctx.data.isAIBot = false;
    }
    ctx.registerMiddleware('is-bot');
  };
}

export { withCtxIsBot };
